import classes from "./Mint.module.css";
import Card from "../components/Card";
import contractabi from "../abi/afp_abi.json";
import ConnectWallet from "./ConnectWallet";

import React, { useState } from "react";
import { BigNumber, ethers } from "ethers";
import {isog} from "../MerkleProof"

function Mint() {
  const [count, setCount] = useState(1);
  const [balance, setBalance] = useState(-1);
  const [inProgress, setInProgress] = useState(false);
  var publicMintEnabled = false;
  var mintRate = -1;

  
  function increment() {
    var max = 2;
    if (count < max) {
      console.log("Count " + count);
      setCount((count) => count + 1);
    }
  }

  function decrement() {
    console.log("Count " + count);
    if (count > 1) {
      setCount((count) => count - 1);
    }
    console.log("Count " + count);
  }

 

  async function getWalletBalance() {
    try {
      const contractAddr = "0xa996F7F3BC647EebC98C684aB0A302c9b85d2FA1";
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const nftToken = new ethers.Contract(
        contractAddr,
        contractabi,
        provider.getSigner()
      );
      const signer = provider.getSigner();
      const address = await signer.getAddress();
      const balance = (await nftToken.balanceOf(address)).toString();
      
      setBalance(balance);
      
    } catch (err) {
      console.log(err);
    }
  }

  async function mintHnadler() {
    try {
      const contractAddr = "0xa996F7F3BC647EebC98C684aB0A302c9b85d2FA1";
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const nftToken = new ethers.Contract(
        contractAddr,
        contractabi,
        provider.getSigner()
      );

      publicMintEnabled = (await nftToken.freeMintEnabled()).toString();
      mintRate = 0;
      try {
        if (publicMintEnabled) {
          var value = -1;
          value = count * mintRate;
          const options = { value: ethers.utils.parseEther(value + "") };
          console.log("value " + value);
          
          try {
            console.log("Minting ");
            const response = await nftToken.mint(
              BigNumber.from(count),
              options
            );
            setInProgress(true);
            console.log(response);

          } catch (err) {
            console.log(err);
            alert(err.data.message);
          }
        } else {
          alert("Unable to mint at the moment");
        }
      } catch (err) {
        console.log(err);
      }
    } catch (err) {
      console.log(err);
      alert("Please conenct to metamask and try again");
    }
    console.log("Its mint time");
  }

  const handleCallback = (address) => {
    console.log("Got Event " + address);
    getWalletBalance(address);
    isog(address)
  };

  return (
    <div className={classes.container}>
      <ConnectWallet callback={handleCallback}></ConnectWallet>
      <div className={classes.mint}>
        <button className={classes.actions} onClick={decrement}>
          -
        </button>
        <h3>{count}</h3>
        <button className={classes.actions} onClick={increment}>
          +
        </button>
        <button className={classes.actionButton} onClick={mintHnadler}>
          Mint
        </button>
        <h4>{(count * 0)} Avax</h4>
      </div>

      {inProgress && (
        <Card style={{ "margin-bottom": "40px" }}>

          <h3>
            Transaction in Progress. Please check your balance after some time.
          </h3>
        </Card>
      )}
  <div className={classes.text}>
      <Card>
          {balance > -1 && <h4>You are Holding {balance} NFT's.</h4>}
          <p>
            Mint at 0 Avax(2 limit per wallet)
            <br />
          </p>
        </Card>

      </div>
    </div>
  );
}

export default Mint;
